export const addMask = (valueToMask: string, mask: string) => {
  let i = 0
  const value = valueToMask.toString()
  return mask.replace(/#/g, () => value[i++])
}
